import React, { useMemo } from 'react';

import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { selectedDate, TreeNode } from '../../../types/interfaces';
import TablePageHeader from '../../../ui/shared/TablePageHeader';
import { TagsComponent } from '../../../ui/TagsComponent';
import { hasChildren } from '../../../utils';

interface TableHeaderProps {
  handleFilterChange: (filter: string, value: string) => void;
  selectedDepartmentsFilter: TreeNode[];
  treeDropDownValue: TreeNode[];
  handleSelectionChange: (selection: TreeNode[]) => void;
  handleDateFilterChange: (selection: selectedDate) => void;
  datepickerDate?: selectedDate;
  handleDeleteTagItem: (taskId: string | number) => void;
  isDepartmentsLoaded: boolean;
  toast: React.MutableRefObject<Toast | null>;
  treeItemToRemove: string | number;
  datepickerLoading: boolean;
  exportHistory: () => void;
}

const LogsTableHeader: React.FC<TableHeaderProps> = ({
  handleFilterChange,
  selectedDepartmentsFilter,
  treeDropDownValue,
  handleSelectionChange,
  handleDateFilterChange,
  datepickerDate,
  handleDeleteTagItem,
  isDepartmentsLoaded,
  treeItemToRemove,
  datepickerLoading,
  exportHistory
}) => {
  const filteredSelection = useMemo(
    () =>
      (selectedDepartmentsFilter as TreeNode[]).filter(
        (node) => !hasChildren(node, treeDropDownValue)
      ),
    [selectedDepartmentsFilter, treeDropDownValue]
  );

  const treeDropdowns = useMemo(
    () => [
      {
        customWidth: '270px',
        selected: selectedDepartmentsFilter,
        value: treeDropDownValue,
        treeDropdownPlaceholder: 'Выбор участков',
        onSelectionChange: handleSelectionChange,
        toDelete: treeItemToRemove,
        isLoading: !isDepartmentsLoaded,
        loadingText: 'Участки загружаются...',
        key: 'departments_dropdown',
        isRed: selectedDepartmentsFilter.length === 0,
        mode: 'tree' as const,
        withoutHr: true
      }
    ],
    [
      handleSelectionChange,
      isDepartmentsLoaded,
      selectedDepartmentsFilter,
      treeDropDownValue,
      treeItemToRemove
    ]
  );

  return (
    <TablePageHeader
      tableName="logs"
      onGlobalSearchChange={(newValue) =>
        handleFilterChange('global', newValue)
      }
      onDatePickerChange={handleDateFilterChange}
      datepickerDate={datepickerDate!}
      datepickerTooltip={{
        from: 'Фильтрация по дате совершенных изменений',
        until: 'Фильтрация по дате совершенных изменений'
      }}
      customButtonsLeft={[
        <Button
          key="export-history-button"
          className="history-export-btn__roles"
          type="button"
          severity="secondary"
          icon="pi pi-file-excel"
          rounded
          onClick={exportHistory}
          tooltip="Выгрузка истории изменения графика"
          tooltipOptions={{position: 'top'}}
        />,
      ]}
      datepicker
      datepickerLoading={datepickerLoading}
      treeDropdowns={treeDropdowns}
      additionalLine={
        selectedDepartmentsFilter.length > 0 ? (
          <div
            style={{ width: '100%', maxHeight: '150px', overflow: 'auto' }}
            id="tags-scroll"
          >
            <TagsComponent
              initialTagsItems={filteredSelection}
              onDelete={handleDeleteTagItem}
            />
          </div>
        ) : (
          <React.Fragment />
        )
      }
    />
  );
};

export default LogsTableHeader;
